/* src/app/module/support/tickets-details/tickets-details.component.scss */
body {
  margin-left: 250px;
  background-color: #F2F4F7;
}
.ticket-details-container {
  padding: 20px;
}
.ticket-details-container h2 {
  margin-top: 10px;
}
.ticket-card {
  background: #fff;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
  margin-bottom: 10px;
}
.ticket-card .ticket-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}
.ticket-card .ticket-header h3 {
  font-size: 20px;
  font-weight: 600;
  margin: 0;
}
.ticket-card .border {
  border: 1px solid #e5e7eb;
}
.ticket-card .ticket-meta {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}
.ticket-card .left-column,
.ticket-card .right-column {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.ticket-card .ticket-body {
  font-size: 15px;
  color: #333;
  line-height: 1.5;
}
.ticket-card .ticket-body p {
  margin-bottom: 8px;
}
.attachments {
  display: flex;
  gap: 12px;
  margin-top: 8px;
}
.attachments .download-btn {
  border: none !important;
  background-color: #fff;
  padding: 8px;
  height: 36px;
  width: 36px;
}
.attachments .download-btn:hover {
  background-color: #f1f5f9;
  border-radius: 50%;
}
.comments-section {
  background: #fff;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
}
.comments-section h4 {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 22px;
  margin-top: 2px;
}
.comments-section .comment {
  display: flex;
  margin-bottom: 16px;
}
.comments-section .comment .avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: #ffecd9;
  color: #ff8c00;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  margin-right: 10px;
  font-size: 14px;
}
.comments-section .comment .comment-content {
  background: #f9fafb;
  padding: 10px 14px;
  border-radius: 8px;
  flex: 1;
}
.comments-section .comment .comment-content .comment-header {
  display: flex;
  justify-content: space-between;
  font-size: 13px;
  font-weight: 500;
  color: #555;
  margin-bottom: 4px;
}
.comments-section .comment .comment-content .comment-header .time {
  font-size: 12px;
  color: #999;
}
.comments-section .comment .comment-content p {
  margin: 0;
  font-size: 14px;
  color: #333;
}
.comments-section .comment .comment-content .comment-attachment {
  margin-top: 4px;
  font-size: 13px;
  color: #555;
}
.comments-section .comment .comment-content .comment-attachment i {
  margin-right: 5px;
  color: #666;
}
.comments-section .no-comments {
  text-align: center;
  padding: 10px;
}
.comments-section .add-comment {
  display: flex;
  align-items: center;
  gap: 10px;
}
.comments-section .add-comment .input-wrapper {
  position: relative;
  width: 100%;
}
.comments-section .add-comment .input-wrapper input {
  width: 100%;
  padding: 14px 40px 14px 12px;
  border: 1px solid #ccc;
  border-radius: 6px;
  font-size: 14px;
}
.comments-section .add-comment .input-wrapper input:focus {
  border-color: orange;
  outline: none;
}
.comments-section .add-comment .input-wrapper input:hover {
  border-color: orange;
}
.comments-section .add-comment .input-wrapper .upload-icon {
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  color: #666;
  font-size: 16px;
}
.comments-section .add-comment .input-wrapper .upload-icon:hover {
  color: #000;
}
.comments-section .add-comment .submit-btn {
  border: none;
  padding: 8px 16px;
  border-radius: 6px;
  cursor: pointer;
  height: 46px;
}
.preview-image {
  margin-top: 8px;
  max-width: 200px;
  max-height: 150px;
  border: 1px solid #ccc;
  border-radius: 4px;
}
.preview-pdf {
  width: 100%;
  height: 300px;
  border: 1px solid #ccc;
  margin-top: 8px;
}
.preview-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}
.preview-modal .modal-content {
  background: #fff;
  padding: 50px;
  max-width: 90%;
  max-height: 90%;
  overflow: auto;
  position: relative;
  border-radius: 8px;
}
.preview-modal .close-btn {
  position: absolute;
  right: 20px;
  top: 10px;
  font-size: 30px;
  cursor: pointer;
}
.file-btn {
  background-color: #f1f5f9;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  padding: 10px;
  font-size: 14px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 6px;
}
.file-btn:hover {
  background-color: #e2e8f0;
}
.file-btn i {
  font-size: 16px;
  color: orange;
}
.ticket-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 10px;
}
.ticket-header .status-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}
.ticket-header .status-btn {
  border: 1px solid #d1d5db;
  border-radius: 8px;
  padding: 8px 16px;
  background-color: #fff;
  height: 40px;
  font-weight: 600;
  color: #000;
}
.ticket-header .status-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
}
.ticket-header .in-progress {
  color: #000;
}
.ticket-body {
  display: flex;
  flex-direction: column;
  gap: 5px;
}
.ticket-body .property-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-wrap: wrap;
}
.ticket-body .property-row .label {
  width: 40%;
  font-weight: 600;
  color: #000;
  margin: 8px 0px;
}
.ticket-body .property-row .value {
  width: 58%;
  color: #344054;
  word-break: break-word;
  margin: 8px 0px;
}
.ticket-body .attach {
  margin-top: 0px;
}
.tag {
  display: inline-flex;
  align-items: center;
  padding: 4px 10px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 500;
}
.tag.open {
  background-color: #FFF1E0;
  color: #D47500;
}
.tag.open::before {
  content: " ";
  display: inline-block;
  width: 8px;
  height: 8px;
  margin-right: 8px;
  border-radius: 50%;
  background-color: #D47500;
}
.tag.inProgress {
  background-color: #EEF4FF;
  color: #3538CD;
}
.tag.inProgress::before {
  content: " ";
  display: inline-block;
  width: 8px;
  height: 8px;
  margin-right: 8px;
  border-radius: 50%;
  background-color: #3538CD;
}
.tag.resolved {
  background-color: #ECFDF3;
  color: #027A48;
}
.tag.resolved::before {
  content: " ";
  display: inline-block;
  width: 8px;
  height: 8px;
  margin-right: 8px;
  border-radius: 50%;
  background-color: #4caf50;
}
.tag.closed {
  background-color: #e5e7eb;
  color: #4b5563;
}
.tag.closed::before {
  content: " ";
  display: inline-block;
  width: 8px;
  height: 8px;
  margin-right: 8px;
  border-radius: 50%;
  background-color: #4b5563;
}
.tag.escalated {
  background-color: #FFF1E0;
  color: #D47500;
}
.tag.escalated::before {
  content: " ";
  display: inline-block;
  width: 8px;
  height: 8px;
  margin-right: 8px;
  border-radius: 50%;
  background-color: #D47500;
}
.chat-input-container {
  width: 100%;
  padding: 10px;
  background: #fff;
  border-radius: 20px;
}
.input-area {
  position: relative;
  display: flex;
  flex-direction: column;
  border: 1px solid #ccc;
  border-radius: 20px;
  padding: 10px 45px 10px 15px;
  background-color: #fafafa;
  overflow: hidden;
}
.input-area textarea {
  border: none;
  outline: none;
  resize: none;
  min-height: 30px;
  max-height: 150px;
  font-size: 1rem;
  background: transparent;
  overflow: hidden;
}
.file-preview-inside {
  display: flex;
  align-items: center;
  background: #eee;
  border-radius: 12px;
  padding: 5px 10px;
  margin-bottom: 5px;
  font-size: 0.9rem;
  color: #333;
  width: fit-content;
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.file-preview-inside .remove-file {
  margin-left: 10px;
  color: red;
  font-weight: bold;
  cursor: pointer;
}
.input-icons {
  position: absolute;
  right: 15px;
  bottom: 9px;
  display: flex;
  gap: 13px;
  align-items: center;
  color: #333;
  font-size: 1.1rem;
  cursor: pointer;
}
.pi-send {
  background-color: #ccc;
  border-radius: 50%;
  padding: 8px;
}
.modalcontent {
  background: white;
  padding: 30px;
  border-radius: 8px;
  position: relative;
  width: 600px;
}
.modalcontent h3 {
  margin-top: 0px;
}
.modal-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 40px;
  gap: 10px;
}
.close-btn {
  position: absolute;
  right: 10px;
  top: 5px;
  font-size: 20px;
  cursor: pointer;
}
.btn {
  font-size: 14px;
  font-weight: 600;
  padding: 8px 16px;
  border-radius: 8px;
  cursor: pointer;
  border: none;
  height: 40px;
}
.btn-cancel {
  background-color: #fff;
  color: #000;
  border: 1px solid #D0D5DD;
}
.btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
}
::ng-deep .custom-timeline ::ng-deep .p-timeline-event {
  text-align: center;
}
::ng-deep .custom-timeline ::ng-deep .custom-marker {
  display: inline-block;
  width: 16px;
  height: 16px;
  background: orange;
  border-radius: 50%;
}
::ng-deep .custom-timeline ::ng-deep .custom-marker.completed {
  background: orange;
}
::ng-deep .custom-timeline ::ng-deep .status {
  font-weight: bold;
  margin-top: 8px;
}
::ng-deep .custom-timeline ::ng-deep .date {
  font-size: 0.85rem;
  color: gray;
}
::ng-deep .p-timeline.p-timeline-horizontal .p-timeline-event-content {
  padding: 0;
  text-align: left;
}
::ng-deep .p-timeline-event-opposite {
  padding: 0 !important;
}
::ng-deep .p-timeline-event {
  display: inline-block !important;
}
/*# sourceMappingURL=tickets-details.component-2IPREQSC.css.map */
